import { useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import shipingService from "../services/shiping-service";

const SorterScanRXNumber = ({ history }) => {
  const { register, getValues, setValue } = useForm({});
  const [loading, setLoading] = useState(false);
  const [scanned, setScanned] = useState(false);
  const getScanDetails = async (e) => {
    if (e.key === "Enter") {
      setLoading(true);
      setScanned(false);
      const rx_num = getValues("rx_num");
      if (!rx_num) {
        const { hide } = cogoToast.error("Please enter RX Number.", {
          hideAfter: 15,
          onClick: () => hide(),
        });
        setLoading(false);
        return;
      }

      try {
        const resp = await shipingService.postSorterScanRxNumber(rx_num);

        if (resp && Object.keys(resp).length === 0) {
          setScanned(true);
          setValue("rx_num", "");
        }

      } catch (error) {

        let errorMessage = error.msg ? error.msg : "Error while submitting Sorter Scan. Please try after sometime.";
        const { hide } = cogoToast.error(errorMessage,
          {
            hideAfter: 15,
            onClick: () => hide(),
          }
        );
        setValue("rx_num", "");
        setScanned(false);
      }

      setLoading(false);
    }
  };

  return (
    <>
      <CipHeader />

      <div className="bg-white w-1/2 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">SORTER SCAN</span>
          </div>
        </div>

        <div className="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
          <div className="flex-auto px-12 py-5">
            <div>
              <span className="text-darkclr font-semibold text-sm">SORTER SCAN</span>
              <input
                type="text"
                name="rx_num"
                id="rx_num"
                autoFocus={true}
                placeholder="Enter RX Code"
                ref={register({ required: "You must enter RX Code" })}
                onKeyDown={getScanDetails}
                className="border focus:outline-none h-10 rounded-md pl-3 text-sm font-normal w-full mb-4"
              />
            </div>
            <div className="h-10">
              {loading && !scanned && (
                <div className="flex items-center space-x-2 text-green-600 text-sm font-medium">
                  <Loader
                    type="Oval"
                    color="#22c55e"
                    height={20}
                    width={40}
                  />
                  <span>Scanning...</span>
                </div>
              )}
              {!loading && scanned && (
                <div className="flex items-center space-x-2 text-green-600 text-sm font-semibold">
                  <span>✅</span>
                  <span>Scanned</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(SorterScanRXNumber)
);